import { getConfigWithMetadata, hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type CreateFavoritesRequest, type CreateFavoritesResponse } from '@pkgs/api/models';
import { createFavorites as generatedCreateFavorites } from '@generated/search-bff/controllers/favorites/favorites';

/**
 * Add favorites to an account.
 * Requires a valid JWT token in the `apiConfig`.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/createFavorites Search API Documentation}
 */
export async function createFavorites(
  createFavoritesRequest: CreateFavoritesRequest,
  apiConfig: ApiConfig,
): Promise<ApiResult<CreateFavoritesResponse>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'createFavorites');

  if (!hasAuthorization(_apiConfig)) {
    console.warn(
      'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
    );
  }

  try {
    const response = await generatedCreateFavorites(createFavoritesRequest, _apiConfig);
    return {
      status: 'success',
      data: response,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
